import * as dateFns from 'date-fns';
import { LineChart } from "./charting";
import { DateRangeControl } from "./date-range-control";

export class LineChartToolbar {
    private dateRangeControl: DateRangeControl;

    constructor(private $containerEl: JQuery, private chart: LineChart, calendarDropDownDirection: "down" | "up" | "auto") {
        if ($containerEl.length === 0) {
            throw new Error("invalid element");
        }

        this.dateRangeControl = new DateRangeControl(
            $containerEl.find(".chart-calendar"),
            async () => {
                await chart.updateWindow(this.dateRangeControl.dateFrom, this.dateRangeControl.dateTo);
            },
            chart.fromDate,
            chart.toDate,
            LineChart.MaxDaysInView,
            calendarDropDownDirection);

        $containerEl.on("click", ".chart-zoom-out", async () => {
            const width = chart.getMillisecondsInView();
            const fromDate = dateFns.subMilliseconds(chart.fromDate, width);
            const toDate = dateFns.addMilliseconds(chart.toDate, width);
            if (dateFns.differenceInDays(toDate, fromDate) <= LineChart.MaxDaysInView) {
                this.dateRangeControl.setDate(fromDate, toDate);
                await chart.updateWindow(fromDate, toDate);
            } else {
                this.dateRangeControl.setDate(fromDate, toDate);
                await chart.updateWindow(chart.fromDate, dateFns.addDays(chart.fromDate, LineChart.MaxDaysInView));
            }
        });

        $containerEl.on("click", ".chart-zoom-in", async () => {
            const width = chart.getMillisecondsInView();
            const fromDate = dateFns.addMilliseconds(chart.fromDate, width / 4);
            const toDate = dateFns.subMilliseconds(chart.toDate, width / 4);
            this.dateRangeControl.setDate(fromDate, toDate);
            await chart.updateWindow(fromDate, toDate);
        });

        $containerEl.on("click", ".chart-back", async () => {
            const width = chart.getMillisecondsInView();
            const fromDate = dateFns.subMilliseconds(chart.fromDate, width);
            const toDate = dateFns.subMilliseconds(chart.toDate, width);
            this.dateRangeControl.setDate(fromDate, toDate);
            await chart.updateWindow(fromDate, toDate);
        });

        $containerEl.on("click", ".chart-forward", async () => {
            const width = chart.getMillisecondsInView();
            const fromDate = dateFns.addMilliseconds(chart.fromDate, width);
            const toDate = dateFns.addMilliseconds(chart.toDate, width);
            this.dateRangeControl.setDate(fromDate, toDate);
            await chart.updateWindow(fromDate, toDate);
        });
    }

    public destroy() {
        this.$containerEl.off();
        delete this.$containerEl;
        this.dateRangeControl.destroy();
        delete this.dateRangeControl;
    }
}
